import {
  DocumentClassAttributes,
  MaterialAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  SubRouteAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule, DecimalPipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, signal } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { MaterialService } from "app/modules/components/material/material/material.service";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { MasterUserInterface } from "app/modules/components/sales/order-generate/interfaces/master-user.interface";
import { OrdersListService } from "app/modules/components/sales/order-list-components/order-list.service";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
  takeUntil,
} from "rxjs";
import { ExportDialogComponent } from "../../../../../layout/export-overlay/dialog/export-dialog.component";
import {
  ORDER_CUSTOMER_LOG_EXPORT_ID,
  ORDER_CUSTOMER_LOG_TITLE,
} from "./exports/order-customer-log.constants";
import { OrderCustomerLogExport } from "./exports/order-customer-log.export";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { MaterialsManagementFiltersComponent } from "app/modules/components/filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { DateHelper } from "app/utils/date.helper";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalConfigService } from "app/services/decimal-config.service";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { ColDef, GridConfig, PageChangedEvent, SmartGridComponent, SortChangedEvent } from "app/shared/components/smart-grid";
import { UserRouteCellRendererComponent } from "app/shared/components/smart-grid/cell-renderers/user-route-cell-renderer/user-route-cell-renderer.component";
import { DateHourCellRendererComponent } from "app/shared/components/smart-grid/cell-renderers/date-hour-cell-renderer/date-hour-cell-renderer.component";
import { CustomerCellRendererComponent } from "../order-customer/cell-renderers/customer-cell-renderer.component";
import { MaterialCellRendererComponent } from "../order-customer/cell-renderers/material-cell-renderer.component";
import { QuantityCellRendererComponent } from "../order-customer/cell-renderers/quantity-cell-renderer.component";
import { CurrencyCellRendererComponent } from "app/shared/components/smart-grid/cell-renderers/currency-cell-renderer/currency-cell-renderer.component";
import { OrderLogModalComponent } from "./order-customer-log-modal/order-customer-log-modal.component";
import { OrderCustomerLogService } from "./order-customer-log.service";
import { SerialNavigationCellRendererComponent } from "../../exchange/request-change/cell-renderers/serial-navigation-cell-renderer.component";
import { ComparisonCellRendererComponent } from './cell-renderers/comparison-cell-renderer.component';
import { CurrencyComparisonCellRendererComponent } from './cell-renderers/currency-comparison-cell-renderer.component';
import { QuantityComparisonUnitCellRendererComponent } from './cell-renderers/quantity-comparison-unit-cell-renderer.component';
import { QuantityBeforeUnitCellRendererComponent } from './cell-renderers/quantity-before-unit-cell-renderer.component';
import { DeletedStatusCellRendererComponent } from './cell-renderers/deleted-status-cell-renderer.component';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';


@Component({
  selector: "app-order-customer",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    FilterComponent,
    MatMenuModule,
    DecimalFormatPipe,
    FilterSectionComponent,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe,
    SmartGridComponent,
    ComparisonCellRendererComponent,
    CurrencyComparisonCellRendererComponent,
    QuantityComparisonUnitCellRendererComponent,
    QuantityBeforeUnitCellRendererComponent,
    DeletedStatusCellRendererComponent,
  ],
  providers: [OrderCustomerLogExport, DecimalPipe],
  templateUrl: "./order-customer-log.component.html",
  styleUrl: "../order-customer/order-customer.component.scss",
})
export class OrderCustomerLogComponent implements OnDestroy {
  getCode = getCode;
  private decimalPipe = new DecimalPipe("en-US");
  type = DocumentTypeEnum.PEDIDO;
  displayedColumns: string[] = [
    "routeUser",
    "serials",
    "date",
    "shipToExternalKeyCode",
    "materialName",
    "soldQuantity",
    //"baseUnitOfMeasure",
    "unitPrice",
    "subTotal",
    "total",
    "actions",
  ];

  data: OrderDetailAttributes[] = [];
  columnDefs: ColDef<OrderDetailAttributes>[] = [];

  gridConfig: GridConfig<any> = {
    rowIdField: "_id" as any,
    emptyState: {
      message: "No encontramos tus resultados!",
      showIcon: true,
    },
    pagination: {
      enabled: true,
      mode: "api",
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
    },
    sorting: {
      enabled: true,
      mode: "api",
      multiColumn: false,
      defaultSort: [{ field: "total" as any, direction: "desc" }],
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
    },
    columnVisibility: {
      enabled: false, // Disabled - now in settings panel
    },
    selection: {
      enabled: false,
    },
    autoSizing: {
      enabled: true,
      includeHeaders: true,
      skipHidden: true,
      padding: 40, // Increased for more spacing
    },
    styling: {
      maxHeight: "85vh",
      minHeight: "80vh",
      density: "comfortable",
      fontSize: "12px",
      cellPaddingX: "3px",
      cellPaddingY: "3px",
    },
    settingsPanel: {
      enabled: true,
      position: "right",
      enableColumnVisibility: true,
      defaultDensity: "compact",
    },
  };

  totalItems = signal<number>(0);
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderDetailAttributes = "total";
  sortDirection: "ASC" | "DESC" = "DESC";

  filter = {
    company: null,
    dateini: new Date(),
    dateend: new Date(),
    warehouseId: null,
    routes: [],
    item: null,
  };

  //active filtro
  isAcive: boolean = true;

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  warehouseList: WarehouseAttributes[] = [];
  warehouseFilterList: WarehouseAttributes[] = [];
  searchWarehouse = "";

  subRouteList: SubRouteAttributes[] = [];
  listFilterSubRouteList: SubRouteAttributes[] = [];
  searchSubRoute = "";

  UMPActive: boolean;

  materialList: MaterialAttributes[] = [];
  searchMaterial = "";
  private searchSubject = new Subject<string>();

  // selectedDocumentClass: string = '0';
  selectedDocumentClass: string[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  documentClassMultiFilterCtrl: FormControl = new FormControl();
  isIndeterminateDocumentClass: boolean = false;
  isCheckedDocumentClass: boolean = false;
  private _onDestroyDocumentClass = new Subject<void>();

  selectedSeller: string = "0";
  selectedWithTravel: string[] = [];

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];

  subs: Subscription[] = [];
  ordersToFilter: string[] = [];

  //BUSCADOR
  searchSubscription: Subscription;
  orders: any;

  form: FormGroup;

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  /**
   * Mapeo de campos del frontend (planos) a rutas del backend (anidadas MongoDB)
   * Usado para traducir el sorting del SmartGrid al formato que espera el API
   */
  private readonly SORT_FIELD_MAPPING: Record<string, string> = {
    // Campo de eliminación (calculado en frontend, no se ordena por backend)
    '_deleted': '_deleted',

    // Campos informativos (estructuras anidadas parciales que ya están aplanadas)
    'serial': 'documentAfterUpdate.serial',
    'creationDateTime': 'documentAfterUpdate.creationDateTime',
    'subRoute.name': 'documentAfterUpdate.subRoute.name',
    'shipTo.name': 'documentAfterUpdate.shipTo.name',
    'materialName.name': 'documentAfterUpdate.detail.material.name',

    // Campos de comparación - AFTER (documentAfterUpdate.detail.*)
    'soldQuantityAfter': 'documentAfterUpdate.detail.soldQuantity',
    'soldQuantity': 'documentAfterUpdate.detail.soldQuantity', // Alias (compatibilidad)
    'pararellQuantityAfter': 'documentAfterUpdate.detail.pararellQuantity',
    'pararellQuantity': 'documentAfterUpdate.detail.pararellQuantity', // Alias
    'unitPriceAfter': 'documentAfterUpdate.detail.unitPrice',
    'unitPrice': 'documentAfterUpdate.detail.unitPrice', // Alias
    'subTotalAfter': 'documentAfterUpdate.detail.subTotal',
    'subTotal': 'documentAfterUpdate.detail.subTotal', // Alias
    'totalAfter': 'documentAfterUpdate.detail.total',
    'total': 'documentAfterUpdate.detail.total', // Alias

    // Campos de comparación - BEFORE (documentBeforeUpdate.detail.*)
    'soldQuantityBefore': 'documentBeforeUpdate.detail.soldQuantity',
    'pararellQuantityBefore': 'documentBeforeUpdate.detail.pararellQuantity',
    'unitPriceBefore': 'documentBeforeUpdate.detail.unitPrice',
    'subTotalBefore': 'documentBeforeUpdate.detail.subTotal',
    'totalBefore': 'documentBeforeUpdate.detail.total',

    // Otros campos del detalle (si se agregan en el futuro)
    'baseQuantity': 'documentAfterUpdate.detail.baseQuantity',
    'baseQuantityAfter': 'documentAfterUpdate.detail.baseQuantity',
    'baseQuantityBefore': 'documentBeforeUpdate.detail.baseQuantity',
  };

  constructor(
    private orderCustomer: OrderCustomerLogService,
    private readonly warehouseService: WarehouseService,
    private readonly subRouteService: SubRouteService,
    private readonly companyService: CompanyService,
    private ordersListService: OrdersListService,
    private snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private orderCustomerLogExport: OrderCustomerLogExport,
    private readonly materialService: MaterialService,
    private readonly searchService: SearchService,
    private activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private fb: FormBuilder,
    private companyCurrencyPipe: CompanyCurrencyPipe,
    private decimalConfigService: DecimalConfigService
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
      startDeliveryDate: [],
      endDeliveryDate: [],
      pickerUpload_start: [],
      pickerUpload_end: [],
    });
  }

  private formatCurrency(value: number): string {
    if (value == null) return "-";
    const decimals = this.decimalConfigService.getDecimals();
    const formattedNum =
      this.decimalPipe.transform(value, `1.${decimals}-${decimals}`) ?? "-";
    if (formattedNum === "-") return "-";
    const symbol = this.companyCurrencyPipe.transform("symbol");
    return `${symbol} ${formattedNum}`;
  }

  private createCurrencyFilterOptions(fieldPath: string) {
    return {
      valueExtractor: (item: any) => {
        const value = item[fieldPath];
        return this.formatCurrency(value);
      },
      customFilterFn: (rowData: any, filterValue: string) => {
        const value = rowData[fieldPath];
        const formattedValue = this.formatCurrency(value);
        if (!formattedValue || formattedValue === "-") return !filterValue;
        return formattedValue === filterValue;
      },
    };
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.initializeColumnDefs();
    this.subs.push(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params["code"]) {
          this.ordersToFilter = params["code"] ? params["code"].split(",") : [];
        }
      })
    );
    this.onHandleSearch();
    // this.fetchDocumentClass();
    // this.getListSeller();
    // this.getListSoldTo(null);
    // this.getListShipTo(null);
  }

  private initializeColumnDefs(): void {
    this.columnDefs = [
      // ============================================================
      // COLUMNAS INFORMATIVAS (SIN CAMBIOS EN LÓGICA)
      // ============================================================
      {
        field: "subRoute.name" as any,
        headerName: "Ruta / Usuario",
        minWidth: 300,
        sortable: true,
        cellRenderer: UserRouteCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const subRoute = item.subRoute;
            const user = item.user;
            const routeName = subRoute?.name ?? "-";
            const userName = user?.name ?? "-";
            return `${routeName} - ${userName}`;
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const subRoute = rowData.subRoute;
            const user = rowData.user;
            const routeName = subRoute?.name ?? "-";
            const userName = user?.name ?? "-";
            const displayValue = `${routeName} - ${userName}`;
            if (!displayValue || displayValue === "- - -") return !filterValue;
            return displayValue === filterValue;
          },
        },
      },
      {
        field: "serial" as any,
        headerName: "Nro. Doc",
        minWidth: 150,
        sortable: true,
        cellRenderer: SerialNavigationCellRendererComponent,
      },
      {
        field: "creationDateTime" as any,
        headerName: "Fecha",
        minWidth: 150,
        sortable: true,
        cellRenderer: DateHourCellRendererComponent,
        cellRendererParams: {
          showHour: false,
        },
        filterOptions: {
          valueExtractor: (item: any) => {
            const date = item.creationDateTime;
            if (!date) return "-";
            return new Date(date).toLocaleDateString("es-ES");
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const date = rowData.creationDateTime;
            if (!date) return !filterValue;
            const formattedDate = new Date(date).toLocaleDateString("es-ES");
            return formattedDate === filterValue;
          },
        },
      },
      {
        field: "shipTo.name" as any,
        headerName: "Cliente",
        minWidth: 200,
        sortable: true,
        cellRenderer: CustomerCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            return item.shipToName ?? "-";
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const value = rowData.shipToName;
            if (!value || value === "-") return !filterValue;
            return value === filterValue;
          },
        },
      },
      {
        field: "materialName.name" as any,
        headerName: "Material",
        minWidth: 200,
        sortable: true,
        cellRenderer: MaterialCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            return item.materialName?.name ?? "-";
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const value = rowData.materialName?.name;
            if (!value || value === "-") return !filterValue;
            return value === filterValue;
          },
        },
      },

      // ============================================================
      // COLUMNAS DE COMPARACIÓN (INTERCALADAS: ANTES, DESPUÉS)
      // ============================================================

      // --- CANTIDAD VENDIDA ---
      {
        field: "soldQuantityBefore" as any,
        headerName: "Cantidad Antes",
        minWidth: 200,
        sortable: true,
        cellClass: "text-gray-600 bg-gray-50",
        cellRenderer: QuantityBeforeUnitCellRendererComponent,
        cellRendererParams: {
          soldBeforeField: 'soldQuantityBefore',
          baseBeforeField: 'baseQuantityBefore',
          parallelBeforeField: 'pararellQuantityBefore',
          soldUnitBeforeField: 'soldUnitOfMeasureBefore',
          baseUnitBeforeField: 'baseUnitOfMeasureBefore',
          parallelUnitBeforeField: 'pararellUnitOfMeasureBefore',
          getUMPActive: () => this.UMPActive,
        },
      },
      {
        field: "soldQuantityAfter" as any,
        headerName: "Cantidad Después",
        minWidth: 200,
        sortable: true,
        cellRenderer: QuantityComparisonUnitCellRendererComponent,
        cellRendererParams: {
          soldBeforeField: 'soldQuantityBefore',
          baseBeforeField: 'baseQuantityBefore',
          parallelBeforeField: 'pararellQuantityBefore',
          soldAfterField: 'soldQuantityAfter',
          baseAfterField: 'baseQuantityAfter',
          parallelAfterField: 'pararellQuantityAfter',
          soldUnitBeforeField: 'soldUnitOfMeasureBefore',
          baseUnitBeforeField: 'baseUnitOfMeasureBefore',
          parallelUnitBeforeField: 'pararellUnitOfMeasureBefore',
          soldUnitAfterField: 'soldUnitOfMeasureAfter',
          baseUnitAfterField: 'baseUnitOfMeasureAfter',
          parallelUnitAfterField: 'pararellUnitOfMeasureAfter',
          getUMPActive: () => this.UMPActive,
        },
      },

      // --- PRECIO UNITARIO ---
      {
        field: "unitPriceBefore" as any,
        headerName: "Precio Antes",
        minWidth: 120,
        sortable: true,
        cellClass: "text-right text-gray-600 bg-gray-50",
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions("unitPriceBefore"),
      },
      {
        field: "unitPriceAfter" as any,
        headerName: "Precio Después",
        minWidth: 150,
        sortable: true,
        cellClass: "text-right",
        cellRenderer: CurrencyComparisonCellRendererComponent,
        cellRendererParams: {
          beforeField: 'unitPriceBefore',
          afterField: 'unitPriceAfter',
        },
        filterOptions: this.createCurrencyFilterOptions("unitPriceAfter"),
      },

      // --- SUBTOTAL ---
      {
        field: "subTotalBefore" as any,
        headerName: "Subtotal Antes",
        minWidth: 120,
        sortable: true,
        cellClass: "text-right text-gray-600 bg-gray-50",
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions("subTotalBefore"),
      },
      {
        field: "subTotalAfter" as any,
        headerName: "Subtotal Después",
        minWidth: 150,
        sortable: true,
        cellClass: "text-right",
        cellRenderer: CurrencyComparisonCellRendererComponent,
        cellRendererParams: {
          beforeField: 'subTotalBefore',
          afterField: 'subTotalAfter',
        },
        filterOptions: this.createCurrencyFilterOptions("subTotalAfter"),
      },

      // --- TOTAL ---
      {
        field: "totalBefore" as any,
        headerName: "Total Antes",
        minWidth: 120,
        sortable: true,
        cellClass: "text-right text-gray-600 bg-gray-50",
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions("totalBefore"),
      },
      {
        field: "totalAfter" as any,
        headerName: "Total Después",
        minWidth: 150,
        sortable: true,
        cellClass: "text-right",
        cellRenderer: CurrencyComparisonCellRendererComponent,
        cellRendererParams: {
          beforeField: 'totalBefore',
          afterField: 'totalAfter',
        },
        filterOptions: this.createCurrencyFilterOptions("totalAfter"),
      },
      {
        field: "_deleted" as any,
        headerName: "Eliminado",
        minWidth: 120,
        sortable: true,
        cellRenderer: DeletedStatusCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            return item._deleted ? 'Eliminado' : 'Activo';
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const isDeleted = rowData._deleted === true;
            const status = isDeleted ? 'Eliminado' : 'Activo';
            return status === filterValue;
          },
        },
      },
    ];
  }

  ngAfterViewInit(): void {
    this.fetchCompanies();
    // this.fetchAllWarehouses();
    this.onFilter();

    this.documentClassMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroyDocumentClass))
      .subscribe(() => {
        this.filterDocumentClasses();
        this.setToggleAllCheckboxStateDocumentClass();
      });

    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((filterValue: string) => {
        this.pageIndex = 1;
        this.search = filterValue;
        this.onFilter();
      });
    this.soldToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }
        this.soldToList = [];
        this.soldToFilterSelected = null;
        this.getListSoldTo(value);

        this.getListReport();
      });

    this.shipToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.shipToList = [];
        this.getListShipTo(value);
        this.getListReport();
      });

    this.setupMaterialSearchControl();
    this.getMaterialList();
  }

  private filterDocumentClasses(): void {
    if (!this.documentClassesList) {
      return;
    }
    let search = this.documentClassMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentClasses.next(this.documentClassesList);
      return;
    } else {
      search = search.toLowerCase();
    }
    const filtered = this.documentClassesList.filter((docClass) =>
      docClass.name.toLowerCase().includes(search)
    );
    this.filteredDocumentClasses.next(filtered);
  }

  private setToggleAllCheckboxStateDocumentClass(): void {
    const selectedCount = this.selectedDocumentClass.length;
    const totalCount = this.documentClassesList.length;

    this.isCheckedDocumentClass =
      selectedCount > 0 && selectedCount === totalCount;
    this.isIndeterminateDocumentClass =
      selectedCount > 0 && selectedCount < totalCount;
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.onFilter();
      }
    );
  }

  onFilter() {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });

    this.getListReport();
  }

  onClearFilter() {
    this.filter = {
      company: this.filter.company,
      dateini: new Date(),
      dateend: new Date(),
      warehouseId: null,
      routes: [],
      item: null,
    };
    this.range.reset({
      start: new Date(),
      end: new Date(),
    });
    this.form.reset({
      start: new Date(),
      end: new Date(),
    });
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getListReport();
  }

  onSortChange(event: SortChangedEvent<OrderDetailAttributes>): void {
    if (event.sortStates && event.sortStates.length > 0) {
      this.sortActive = event.sortStates[0]
        .field as keyof OrderDetailAttributes;
      this.sortDirection =
        event.sortStates[0].direction === "asc" ? "ASC" : "DESC";
    }
    this.getListReport();
  }

  onPageChange(event: PageChangedEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getListReport();
  }

  getListReport() {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField() as keyof OrderDetailAttributes,
      sortDirection: this.sortDirection,
    };

    // const adjustedStart = new Date(this.filter.dateini);
    // adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

    // const adjustedEnd = new Date(this.filter.dateend);
    // adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

    let filter: IFilters = {
      type: this.type,
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
      startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
      endTrip:
        DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ??
        null,
      end_startTrip: DateHelper.getStartOfDay(
        this.form.get("end_startTrip")?.value
      ),
      end_endTrip:
        DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ??
        null,
      startDeliveryDate: DateHelper.getStartOfDay(
        this.form.get("startDeliveryDate")?.value
      ),
      endDeliveryDate:
        DateHelper.getEndOfDay(this.form.get("endDeliveryDate")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startDeliveryDate")?.value) ??
        null,
      pickerUpload_start: DateHelper.getStartOfDay(
        this.form.get("pickerUpload_start")?.value
      ),
      pickerUpload_end:
        DateHelper.getEndOfDay(this.form.get("pickerUpload_end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("pickerUpload_start")?.value) ??
        null,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value, //
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value, //
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      typeCustomer: this.selectedCustomerType.length
        ? this.selectedCustomerType
        : null,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,
      ordersToFilter: null,
    };

    if (
      this.ordersToFilter &&
      this.ordersToFilter.length > 0 &&
      (this.search == undefined || this.search == null || this.search == "")
    ) {
      filter.ordersToFilter = this.ordersToFilter;
      filter.start = null;
      filter.end = null;
      filter.startTrip = null;
      filter.endTrip = null;
      filter.end_startTrip = null;
      filter.end_endTrip = null;
    }

    this.orderCustomer.findAllWithCount(options, filter).subscribe({
      next: (res: IPaginationResult<OrderDetailAttributes>) => {
        const documents = res?.data?.[0]?.data ?? [];
        const apiTotal = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.orders = documents;
        let totalFilteredDetails = 0;

        const flatData = documents.flatMap((item: any) => {
          const document = item.documentAfterUpdate;
          const documentBefore = item.documentBeforeUpdate;
          const updatedPositions = item.detailsPositionsUpdated || []; // Ejemplo: [1, 2]

          const results = [];

          // ============================================================
          // Process all updated positions
          // ============================================================
          const filteredDetails = document.detail.filter((detailItem) =>
            updatedPositions.includes(detailItem.position)
          );

          totalFilteredDetails += filteredDetails.length;

          filteredDetails.forEach((detailItem) => {
            // Buscar el detalle correspondiente en documentBeforeUpdate por position
            const detailBefore = documentBefore?.detail?.find(
              (d) => d.position === detailItem.position
            );

            results.push({
              ...item,
              ...detailItem,
              user: document.user,
              serial: document.serial,
              type: document.type,
              class: document.class,
              sourceTransactions: document.sourceTransactions,
              creationDateTime: document.creationDateTime,
              subRoute: document.subRoute,
              shipTo: document.shipTo,
              responsibleBusinessPartner: document.responsibleBusinessPartner,
              // Flatten data for CustomerCellRenderer and MaterialCellRenderer
              materialName: detailItem?.material,
              shipToExternalKeyCode: document?.shipTo?.externalKeys?.code ?? "-",
              shipToName: document?.shipTo?.name ?? "-",

              // ============================================
              // CAMPOS "BEFORE" (documentBeforeUpdate)
              // ============================================
              soldQuantityBefore: detailBefore?.soldQuantity ?? null,
              baseQuantityBefore: detailBefore?.baseQuantity ?? null,
              pararellQuantityBefore: detailBefore?.pararellQuantity ?? null,
              soldUnitOfMeasureBefore: detailBefore?.soldUnitOfMeasure ?? null,
              baseUnitOfMeasureBefore: detailBefore?.baseUnitOfMeasure ?? null,
              pararellUnitOfMeasureBefore: detailBefore?.pararellUnitOfMeasure ?? null,
              unitPriceBefore: detailBefore?.unitPrice ?? null,
              subTotalBefore: detailBefore?.subTotal ?? null,
              totalBefore: detailBefore?.total ?? null,

              // ============================================
              // CAMPOS "AFTER" (documentAfterUpdate)
              // ============================================
              soldQuantityAfter: detailItem?.soldQuantity ?? null,
              baseQuantityAfter: detailItem?.baseQuantity ?? null,
              pararellQuantityAfter: detailItem?.pararellQuantity ?? null,
              soldUnitOfMeasureAfter: detailItem?.soldUnitOfMeasure ?? null,
              baseUnitOfMeasureAfter: detailItem?.baseUnitOfMeasure ?? null,
              pararellUnitOfMeasureAfter: detailItem?.pararellUnitOfMeasure ?? null,
              unitPriceAfter: detailItem?.unitPrice ?? null,
              subTotalAfter: detailItem?.subTotal ?? null,
              totalAfter: detailItem?.total ?? null,

              // ============================================
              // CAMPOS COMPARTIDOS (para cell renderers)
              // ============================================
              material: detailItem?.material,
              baseUnitOfMeasure: detailItem?.baseUnitOfMeasure,
              pararellUnitOfMeasure: detailItem?.pararellUnitOfMeasure,
              soldUnitOfMeasure: detailItem?.soldUnitOfMeasure,

              // ============================================
              // CAMPO DE ELIMINACIÓN
              // ============================================
              _deleted: detailItem.statusId === StatusEnum.INACTIVE,
            });
          });

          return results;
        });
        this.data = flatData;
        console.log({apiTotal});
        this.totalItems.set(apiTotal);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener reporte",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getSortField(): string {
    const frontendField = this.sortActive as string;

    // Traducir campo del frontend a la ruta que espera el backend
    const backendField = this.SORT_FIELD_MAPPING[frontendField];

    if (backendField) {
      return backendField;
    }

    return frontendField;
  }

  //filter
  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
      }
    });
  }

  private fetchAllWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.warehouseFilterList = this.warehouseList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching warehouses",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsWarehouse(event) {
    if (!this.warehouseList) {
      return;
    }
    let search = event;
    if (!search) {
      this.warehouseFilterList = this.warehouseList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.warehouseFilterList = this.warehouseList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changeWarehouse(event): void {
    this.subRouteList = [];
    this.listFilterSubRouteList = [];
    this.getAllRutas();
  }

  private getAllRutas(): void {
    this.subRouteService
      .findToWarehouse(this.filter.warehouseId ? [this.filter.warehouseId] : [])
      .subscribe({
        next: (res) => {
          this.subRouteList = res.data;
          this.listFilterSubRouteList = this.subRouteList.slice();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching route",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  changueOptionsSubRoute(event) {
    if (!this.subRouteList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSubRouteList = this.subRouteList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSubRouteList = this.subRouteList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  onExportButtonPressed() {
    if (!this.orderCustomerLogExport.canStartTask()) return;
    const dialogRef = this.matDialog.open(ExportDialogComponent, {
      data: { title: ORDER_CUSTOMER_LOG_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderCustomerLogExport.export(
          options.format,
          options.range,
          this.totalItems(),
          this.pageSize,
          this.pageIndex,
          ORDER_CUSTOMER_LOG_EXPORT_ID,
          ORDER_CUSTOMER_LOG_TITLE
        );
      }
    });
  }

  onDocumentClassSelectionChange(selectedValues: string[]): void {
    this.selectedDocumentClass = selectedValues;
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching sellers",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  fetchSoldToName = (soldtoId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldtoId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  private setupMaterialSearchControl(): void {
    this.searchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchMaterial = searchTerm;
          this.getMaterialList();
        }
      });
  }

  changueOptionsMaterial(event) {
    this.searchSubject.next(event);
  }

  private getMaterialList(): void {
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.materialService
      .findAllWithCount(
        materialOptions,
        this.filter.company ? this.filter.company : []
      )
      .subscribe({
        next: (res: IPaginationResult<MaterialAttributes>) => {
          this.materialList = res?.data?.[0]?.data ?? [];
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al traer registros",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: this.type,
    };
    // this.ordersListService.fetchDocumentClasses(dataToFilter).subscribe((res) => {
    //   this.documentClassesList = res.data;
    // })
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  getActiveFiler() {
    this.isAcive = environment.activeFilter;
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  openOrderLogModal(element: any) {
    const fullDocument = this.orders.find(
      (doc) =>
        doc.documentAfterUpdate.serial === element.serial &&
        doc.detailsPositionsUpdated?.includes(element.position)
    );

    if (!fullDocument) {
      this.snackBar.open(
        "No se encontró documento con ese serial y posición",
        "Cerrar",
        { duration: 5000 }
      );
      return;
    }

    this.matDialog.open(OrderLogModalComponent, {
      width: "800px",
      data: {
        before: fullDocument.documentBeforeUpdate,
        after: fullDocument.documentAfterUpdate,
        updatedPositions: fullDocument.detailsPositionsUpdated,
      },
    });
  }

  isThereOrderSourceTransaction(element: any): boolean {
    return element.type.code == DocumentTypeEnum.PEDIDO;
  }

  goToOrder(element: OrderAttributes) {
    if (element?.serial && Array.isArray(element?.sourceTransactions)) {
      const orderIds = element?.serial;

      if (orderIds.length > 0) {
        const queryParams = { orderIds: orderIds };
        const urlTree = this.router.createUrlTree(
          ["master", "sales", "orders-list"],
          { queryParams }
        );
        const absoluteUrl =
          window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, "_blank");
      }
    }
  }
}
